import { LanguageVersions, LanguageVm } from "../../../../interfaces/meMenuInterfaces/interfaces";

export const buildPrimaryLanguageVm = (
    primaryLanguage: LanguageVersions | null,
    languages: LanguageVersions[] = []
): LanguageVm | null => {
    const code = primaryLanguage?.isoCode;
    if (!code) return null;
    const label = primaryLanguage?.name || languages.find((l) => l.isoCode === code)?.name || code;

    return { code, label };
};

export const buildSelectedLanguageVm = (
    selectedLanguageCode: string | null,
    primaryVm: LanguageVm | null,
    languages: LanguageVersions[] = []
): LanguageVm | null => {
    const code = selectedLanguageCode || primaryVm?.code || "";
    if (!code) return null;
    const name = languages.find((l) => l.isoCode === code)?.name || code;
    const label = primaryVm?.code === code ? primaryVm.label : name;

    return { code, label };
};
